import { Grid } from '@mui/material';
import MetricCard from '../shared/MetricCard';
import { driftSummaryColors } from './screenDriftStyles';

export default function DriftSummary({ summary }) {
  return (
    <Grid container spacing={1.5}>
      <Grid item xs={6} md={2}>
        <MetricCard
          label="Regressions"
          value={summary.regressions || 0}
          color={driftSummaryColors.regression}
        />
      </Grid>
      <Grid item xs={6} md={2}>
        <MetricCard label="Fixed" value={summary.fixed || 0} color={driftSummaryColors.fixed} />
      </Grid>
      <Grid item xs={6} md={2}>
        <MetricCard label="Stable" value={summary.passed || summary.stable || 0} />
      </Grid>
      <Grid item xs={6} md={2}>
        <MetricCard
          label="New"
          value={summary.new || summary.added || 0}
          color={driftSummaryColors.new}
        />
      </Grid>
      <Grid item xs={6} md={2}>
        <MetricCard
          label="Removed"
          value={summary.removed || 0}
          color={driftSummaryColors.removed}
        />
      </Grid>
    </Grid>
  );
}
